<template>
  <a-card title="Select Date Range" class="relative top-10">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <a-form-item label="From">
        <a-date-picker valueFormat="YYYY-MM-DD" :format="dateFormat" v-decorator="['from_date',
            {
              initialValue: initialMonthCurrentDate,
              rules: [
                { validator: (rule,value) => validateCurrent(value)      , required:false , message: `The date should be smaller than today\'s date.` },
                { validator: (rule,value) => validateCheckDateFrom(value,'to_date'), required:false , message: 'The start date must be smaller than the end date.\n' }
            ]}
          ]"
        />
      </a-form-item>
      <a-form-item label="To">
        <a-date-picker valueFormat="YYYY-MM-DD" :format="dateFormat" v-decorator="['to_date',
            {
              initialValue: currentDateWithFormat,
              rules: [
                { validator: (rule,value) => validateCurrent(value)    , required:false , message: 'The date should be smaller than today\'s date.' },
                { validator: (rule,value) => validateCheckDateTo(value,'from_date'), required:false , message: 'The end date must be greater than the start date.\n' }
            ]}
          ]"
        />
      </a-form-item>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import mixin from '@/views/mixin/mixin'
export default {
  name: "DateRangeComponent",
  mixins:[mixin],
  props:{
    dateForm: {
      type: Object
    }
  },
  data(){
    return {

    }
  },
  computed: {
    initialMonthCurrentDate() {
      return moment(this.current_date).subtract(1, 'month').format('YYYY-MM-DD')
    }
  },
  methods: {
    validateCurrent(date){
      if (date)
        return moment(date).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')
      return true
    },
  }
}
</script>
